// src/components/Absence/AbsenceFormDialog.js
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
} from "@mui/material";
import axiosApi from "../Utils/axiosApi";
import checkPermission from '../Utils/checkPermission';
const AbsenceFormDialog = ({
  open,
  onClose,
  onSave,
  absence,
  hostelId,
  hostelName,
  hostelerId,
  hostelerName,
}) => {
  const [formData, setFormData] = useState({
    hostelerId,
    hostelId,
    hostelerName,
    hostelName,
    leaveStartDate: "",
    leaveEndDate: "",
    remarks: "",
    leaveRequestStatus: "PENDING",
  });

  useEffect(() => {
    if (absence) {
      setFormData({
        ...absence,
        hostelerId,
        hostelId,
        hostelerName,
        hostelName,
      });
    } else {
      setFormData({
        hostelerId,
        hostelId,
        hostelerName,
        hostelName,
        leaveStartDate: "",
        leaveEndDate: "",
        remarks: "",
        leaveRequestStatus: "PENDING",
      });
    }
  }, [absence, hostelId, hostelName, hostelerId, hostelerName]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    const payloadData = {
      ...formData,
      hostelId,
      hostelerId,
      leaveRequestStatus: formData.leaveRequestStatus?.toUpperCase() || "PENDING", // ensure backend enum format
    };

    // ✅ Basic validation
    if (!payloadData.leaveStartDate || !payloadData.leaveEndDate) {
      alert("Start date and End date are required.");
      return;
    }
    if (new Date(payloadData.leaveEndDate) < new Date(payloadData.leaveStartDate)) {
      alert("End date cannot be before start date.");
      return;
    }

    try {
      if (formData.id) {
        await axiosApi.post(
          "/hostelerLeaveRequest/updateHostelLeaveRequest",
          { hostelerLeaveRequestDTO: payloadData }
        );
      } else {
        await axiosApi.post(
          "/hostelerLeaveRequest/createHostelLeaveRequest",
          { hostelerLeaveRequestDTO: payloadData }
        );
      }

      if (onSave) onSave(payloadData);
      onClose();
    } catch (err) {
      console.error("Error saving absence:", err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Absence Form</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} mt={1}>
          {/* Non-editable fields */}
          <TextField
            label="Hosteler Name"
            name="hostelerName"
            value={formData.hostelerName}
            fullWidth
            disabled
          />
          <TextField
            label="Hostel Name"
            name="hostelName"
            value={formData.hostelName}
            fullWidth
            disabled
          />

          {/* Editable fields */}
          <TextField
            label="Start Date"
            name="leaveStartDate"
            type="date"
            value={formData.leaveStartDate}
            onChange={handleChange}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="End Date"
            name="leaveEndDate"
            type="date"
            value={formData.leaveEndDate}
            onChange={handleChange}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="Remarks"
            name="remarks"
            value={formData.remarks}
            onChange={handleChange}
            fullWidth
            multiline
            rows={3}
          />

          {/* 🔥 New Dropdown for status */}
		 
         <TextField
  select
  label="Status"
  name="leaveRequestStatus"
  value={formData.leaveRequestStatus}
  onChange={handleChange}
  fullWidth
  SelectProps={{ native: true }}
  disabled={!checkPermission("Hostel", "Hosteler List", "UPDATEABSENTSTATUSFIELD")}
>
  <option value="PENDING">Pending</option>
  <option value="APPROVED">Approved</option>
</TextField>

        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AbsenceFormDialog;
